import type { SignableDocument, SignableDocumentActivity } from '../types/documents.types'

export const useDocumentActivities = (document: SignableDocument) => {
  return (
    document?.activities.filter((activity: SignableDocumentActivity) => activity?.definition?.type === 'Document') ?? []
  )
}
